import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  return (
    <section id="about" className="py-5" style={{ padding: '80px 0' }}>
      <Container>
        <Row>
          <Col lg={8} className="mx-auto">
            <h2 
              className="text-center mb-5"
              data-aos="fade-up"
              style={{
                position: 'relative',
                marginBottom: '3rem'
              }}
            >
              About Us
              <div
                style={{
                  content: '""',
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '60px',
                  height: '3px',
                  background: 'linear-gradient(45deg, #007bff, #0056b3)',
                  borderRadius: '2px'
                }}
              />
            </h2>
            
            <div 
              className="about-content"
              data-aos="fade-up"
              data-aos-delay="200"
              style={{
                fontSize: '1.1rem',
                lineHeight: '1.8'
              }}
            >
              <p 
                className="lead mb-4"
                style={{ fontSize: '1.25rem', fontWeight: '500' }}
              >
                Altogroup is a Sharjah UAE-based investment holding company with a global outlook — dedicated to advancing innovation, digital transformation, and intelligent enterprise growth worldwide.
              </p>
              
              <p className="mb-4">
                We invest strategically in technology-driven commercial ventures, focusing on tech development, digital infrastructure, and advanced data processing systems. Our mission is to empower businesses through innovation, efficiency, and future-ready solutions.
              </p>
              
              <p className="mb-4">
                At the core of our vision lies a commitment to state-of-the-art technologies, smart data ecosystems, and high-performance computing systems that enable seamless connectivity, analytics, and automation. We see technology not as an asset, but as a catalyst for progress.
              </p>
              
              <p className="mb-4">
                Through forward-thinking leadership and global partnerships, Altogroup identifies and scales opportunities that redefine industries — from AI and cloud computing to online data platforms and intelligent system integration.
              </p>
              
              <p className="mb-0">
                Alto Holding parent company is a new entity and still undergoing its online presence development.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
